import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import './Component/Style.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Home from './Component/Home';
import axios from "axios";

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get("https://admin.victoryvalleyrwa.com/api/home-data")
      .then(res => {
        console.log(res.data);
        setData(res.data);
      })
      .catch(err => {
        console.error("API Error:", err);
      });
  }, []);

  if (!data) return <p className='vh-100 col-12 text-center align-content-center'>
    <svg
    width="50px"
    height="50px"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
    fill="#0098d4ff"
  >
    <circle
      cx="25"
      cy="25"
      r="20"
      stroke="#00b13bff"
      strokeWidth="5"
      fill="none"
    />
    <circle
      cx="25"
      cy="25"
      r="20"
      stroke="#0043a7ff"
      strokeWidth="5"
      strokeDasharray="31.4 31.4"
      strokeLinecap="round"
      fill="none"
      strokeDashoffset="0"
    >
      <animate
        attributeName="stroke-dashoffset"
        from="0"
        to="62.8"
        dur="1.5s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
  </p>;

  return (
    <>
      <BrowserRouter>
        <Header headerInfo={data} />
        <Home homeContent={data} />
        <Footer footerInfo={data} />
      </BrowserRouter>
    </>
  );
}

export default App;
